import React from 'react';
const CaseStudyCard = ({
  image,
  title,
  category,
  url
}) => {
  return <a href={url} target="_blank" rel="noopener noreferrer" className="block group" data-id="element-14">
      <div className="overflow-hidden rounded-sm mb-4" data-id="element-15">
        <img src={image} alt={title} className="w-full h-64 object-cover object-center transition-transform duration-500 group-hover:scale-105" data-id="element-16" />
      </div>
      <div className="text-zinc-500 text-sm mb-1" data-id="element-17">{category}</div>
      <h3 className="font-serif text-xl group-hover:text-teal-dark transition-colors text-zinc-900" data-id="element-18">
        {title}
      </h3>
    </a>;
};
export const CaseStudies = () => {
  return <section id="case-studies" className="py-24 bg-zinc-100 text-zinc-800" data-id="element-19">
      <div className="container-custom" data-id="element-20">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-21">
          <h2 className="font-serif text-4xl mb-6 text-zinc-900" data-id="element-22">
            Our <span className="accent-text" data-id="element-23">Case Studies</span>
          </h2>
          <p className="text-zinc-600" data-id="element-24">
            We've helped businesses and entrepreneurs launch dozens of products
            across various industries. Here are some examples of our work.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-25">
          <CaseStudyCard image="https://uploadthingy.s3.us-west-1.amazonaws.com/ruaNjhdcVgghenG2UuPjFs/Screenshot_2025-09-30_095414.png" title="LexSquire" category="Legal Intake" url="https://lexsquire.legal/" data-id="element-26" />
          <CaseStudyCard image="https://uploadthingy.s3.us-west-1.amazonaws.com/33G6ZbYgGvEyjq8VtdBpF6/Sun_Title_Sunny_Portfolio.png" title="Ask Sunny" category="Real Estate" url="https://asksunny.ai/chat/" data-id="element-27" />
          <CaseStudyCard image="https://uploadthingy.s3.us-west-1.amazonaws.com/9ExaLcpCvwvsDPopXm8JtA/Screenshot_2025-09-30_095538.png" title="Story Bunny" category="Consumer" url="https://storybunny.ai/" data-id="element-28" />
          <CaseStudyCard image="https://uploadthingy.s3.us-west-1.amazonaws.com/puXzF3cSrxCoc91m216F1y/Screenshot_2025-09-30_095740.png" title="Voxie" category="Consumer Telecom" url="https://voxie.network" data-id="element-29" />
        </div>
      </div>
    </section>;
};